import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { authMe, authLogout, authLogin, authRegister } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = not auth'd, object = user
  const [user, setUser] = useState(null);

  const checkAuth = useCallback(async () => {
    try {
      const u = await authMe();
      setUser(u);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password, inviteToken = "") => {
    const userData = await authLogin(email, password, inviteToken);
    setUser(userData);
    return userData;
  };

  const signup = async (data) => {
    const userData = await authRegister(data);
    setUser(userData);
    return userData;
  };

  const logout = async () => {
    try {
      await authLogout();
    } catch { /* ignore */ }
    setUser(false);
  };

  const loginSuccess = (userData) => {
    setUser(userData);
  };

  return (
    <AuthContext.Provider value={{ user, login, signup, logout, loginSuccess, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
